import React from 'react';
import { TextField } from '@mui/material';
import { isValidFunction } from '../../../utils/nullChecks';
import { OutlinedTextFieldProps } from '../types';

const OutlinedTextField = (props: OutlinedTextFieldProps) => {
    const {
        onChange,
        ...otherProps
    } = props;

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        console.log('outlined-text-filed-value', event.target.value);
        if (isValidFunction(onChange)) {
            onChange(event.target.value, event);
        }
    };

    return (
        <TextField
            variant="outlined"
            size="small"
            onChange={handleChange}
            {...otherProps}
        />
    );
};

export default OutlinedTextField;
